import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../theme';
import { Eyebrow } from '../Eyebrow';
import { VibeTag } from '../atoms/VibeTag';
const MAX_VIBES = 4;
const StatBlock = ({ value, label, valueStyles, labelStyles }) => (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }, children: [_jsx("span", { style: valueStyles, children: value }), _jsx("span", { style: labelStyles, children: label })] }));
export const TasteProfileCard = forwardRef(({ vibes, eventCount, venueCount, memoryCount, className, style, ...rest }, ref) => {
    const theme = useTheme();
    const visibleVibes = vibes.slice(0, MAX_VIBES);
    const containerStyles = {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.10)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderRadius: 'var(--r-lg, 16px)',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        ...style,
    };
    const vibesRowStyles = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        minHeight: 22,
    };
    const statsRowStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        paddingTop: 8,
        borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    };
    const statValueStyles = {
        fontFamily: theme.typography.fontFamilyMono ?? theme.typography.fontFamily,
        fontSize: 22,
        fontWeight: theme.typography.fontWeight.semibold,
        color: theme.colors.text,
        lineHeight: 1.1,
    };
    const statLabelStyles = {
        fontFamily: theme.typography.fontFamilyDisplay ?? theme.typography.fontFamily,
        fontSize: theme.typography.fontSize.caption,
        color: theme.colors.textMuted,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginTop: 4,
    };
    const placeholderStyles = {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize.small,
        color: theme.colors.textMuted,
        fontStyle: 'italic',
    };
    return (_jsxs("div", { ref: ref, className: className, style: containerStyles, ...rest, children: [_jsx(Eyebrow, { children: "YOUR VIBE" }), _jsx("div", { style: vibesRowStyles, "data-testid": "taste-profile-vibes", children: visibleVibes.length > 0 ? (visibleVibes.map((vibe) => _jsx(VibeTag, { children: vibe }, vibe))) : (_jsx("span", { style: placeholderStyles, children: "Save events to discover your vibe" })) }), _jsxs("div", { style: statsRowStyles, children: [_jsx(StatBlock, { value: eventCount, label: "Events", valueStyles: statValueStyles, labelStyles: statLabelStyles }), _jsx(StatBlock, { value: venueCount, label: "Venues", valueStyles: statValueStyles, labelStyles: statLabelStyles }), _jsx(StatBlock, { value: memoryCount, label: "Memories", valueStyles: statValueStyles, labelStyles: statLabelStyles })] })] }));
});
TasteProfileCard.displayName = 'TasteProfileCard';
